<div class="page-header">
  <div class="container">
    <div class="content">
      <procure-loading-indicator [active]="isLoading()" />
      @if (fileUploadsPending()) {
        <procure-form-header-uploads [uploadFieldsProgress]="uploadFieldsProgress()" />
      }
      <procure-page-header-topbar
        class="topbar"
        [url]="url()"
        [sapAribaLink]="sapAribaLink()"
        [orbisLink]="orbisLink()"
        [sncrpLink]="sncrpLink()"
        [gravityLink]="gravityLink()"
        [xapienLink]="xapienLink()"
        [ecoVadisLink]="ecoVadisLink()"
        [breadcrumbs]="breadcrumbs()"
        [entityClickable]="entityClickable()"
      />
    </div>
    <div class="actions">
      <ng-content select="[actions]" />
    </div>
  </div>
</div>
@if (!hideHeader()) {
  <procure-card
    condensed
    [class]="`title-wrapper ${status()?.color}`"
    [class.admin]="isAdmin()"
    [loading]="isLoading()"
  >
    @if (confidentiality(); as confidentiality) {
      <div class="confidentiality">
        <procure-confidential-icon
          class="confidentiality-icon"
          [tooltip]="confidentiality"
        />
      </div>
    }

    @if (internal(); as internal) {
      <div class="internal">
        <mat-icon class="internal-icon"> emergency </mat-icon>
        <span class="internal-label"> Internal<br />supplier </span>
      </div>
    }
    <procure-page-header-title
      [control]="control()"
      [fallbackTitle]="fallbackTitle()"
      [revision]="revision()"
      [tooltip]="tooltip()"
      [label]="label()"
      [title]="control()?.value || title()"
      [isTitleEditable]="isTitleEditable()"
      [autofocus]="autofocusTitle()"
    >
      <ng-content
        select="[titleSuffix]"
        ngProjectAs="[titleSuffix]"
      />
    </procure-page-header-title>
    <procure-page-header-statuses
      [status]="status()"
      [template]="template()"
      [additionalStatus]="additionalStatus()"
      [priority]="priority()"
      [isTitleEditable]="isTitleEditable()"
    />
  </procure-card>
}
<ng-content />
@if (maintenanceText()) {
  <procure-card
    class="maintenance"
    [loading]="isLoading()"
  >
    {{ maintenanceText() }}
  </procure-card>
}
